import { logger } from '@myrealtrip/nextjs';
import { useQuery } from '@tanstack/react-query';

import { useWebView } from '@myrealtrip/device-detect';
import type { BadgeStyle, VerticalItem, LocalNavVerticalItem } from '@myrealtrip/layout-ui';
import { discoveryApi } from '~endpoints/Discovery';
import { ShortcutResponse } from '~models/DiscoveryDto';
import { RequestParams } from '~utils/https/HttpClientFetch';

type VerticalItems = {
  vertical_items: VerticalItem[];
  sub_vertical_items: VerticalItem[];
  lnb_vertical_items: LocalNavVerticalItem[];
};

const parseDiscoveryShortcutResponseToVerticalItems = (
  response: ShortcutResponse,
): VerticalItems => {
  return {
    vertical_items: response.data.shortCut.shortcuts.map((shortcut) => ({
      id: shortcut.id,
      // TODO : CODE 없음. 확인 필요
      code: 'TEST_CODE',
      title: shortcut.title,
      // TODO : 포지션 없음. 확인 필요
      position: 0,
      badge: shortcut.badge,
      badge_style: shortcut.badgeStyle as BadgeStyle,
      // TODO : CMS_ICON_ID 없음. 확인 필요
      cms_icon_id: 0,
      // TODO : CMS_ICON_CODE 없음. 확인 필요
      cms_icon_code: 'TEST_CODE',
      cms_icon_url: shortcut.iconImageUrl,
      level: 1,
      link: {
        mobile_web: shortcut.linkMoWeb,
        desktop: shortcut.linkWeb,
        mobile: shortcut.linkApp,
      },
    })),
    sub_vertical_items: [],
    lnb_vertical_items: response.data.shortCut.shortcuts.map((shortcut) => ({
      // TODO : ID 다름. 확인 필요
      id: shortcut.id,
      // TODO : CODE 없음. 확인 필요
      code: 'TEST_CODE',
      title: shortcut.title,
      // TODO : lnb_required_badge 없음. 확인 필요
      lnb_required_badge: false,
      // TODO : 포지션 없음. 확인 필요
      position: 0,
      level: 1,
      link: {
        mobile_web: shortcut.linkMoWeb,
        desktop: shortcut.linkWeb,
      },
    })),
  };
};

export async function fetchShortcut(requestParams?: RequestParams) {
  try {
    return (await discoveryApi.v1.fetchShortcut(requestParams)) || null;
  } catch (error) {
    logger.error(error);
    return null;
  }
}

export const discoveryKeys = {
  shortcut: () => ['discovery', 'shortcut'] as const,
};

export function useVerticalItems() {
  const { isWebView } = useWebView();

  return useQuery({
    queryKey: discoveryKeys.shortcut(),
    queryFn: () => discoveryApi.v1.fetchShortcut(),
    select: (response) =>
      response ? parseDiscoveryShortcutResponseToVerticalItems(response) : null,
    enabled: !isWebView,
  });
}
